import React from 'react'
import { useIntl } from 'react-intl'
import { useWhistleblowingCases } from 'contexts/whistleblowing-cases'
import { compact } from 'utilities/array'
import Filter from 'components/filter'
import CaseStatus from 'pages/whistleblowing/components/case-status'
import { unresolvedStatusesFilter } from 'pages/whistleblowing/constants'

const WhistleblowingCasesFilter = props => {
    const { formatMessage } = useIntl()

    const { namespace: salt } = props

    const {
        filter,
        filterOverride,
        setCasesFilter: setFilter,
        kases: items,
        fetching,
        hasFetched
    } = useWhistleblowingCases()

    const advancedFields = compact([
        {
            type: 'checkboxes',
            name: 'statuses',
            label: formatMessage({
                id: 'noun_status',
                defaultMessage: 'Status'
            }),
            field: {
                defaultValue: [],
                options: unresolvedStatusesFilter.map(status => ({
                    id: status,
                    name: <CaseStatus status={status} />
                }))
            },
            empty: []
        }
    ])

    return (
        <Filter
            {...props}
            filter={filter}
            setFilter={filter => setFilter(filter, 'unresolved')}
            advancedFields={advancedFields}
            items={items}
            fetching={fetching}
            hasFetched={hasFetched}
            memoryFilterOptions={{
                ...(props.memoryFilterOptions ?? null),
                ...(filterOverride ? { enabled: false } : null)
            }}
            salt={salt} />
    )
}

export default WhistleblowingCasesFilter
